import React, { useContext } from 'react'
import { ReactSVG } from 'react-svg'

import * as style from './styles.module.css'

import { ThemeContext } from '@/context'
import { themes } from '@/consts'
import { CustomLink } from '@/components'

import MapImage from '/static/images/map.png'
import MapDmImage from '/static/images/map-dm.png'

interface Props {
    name: string
    address?: string
    social_media: GatsbyTypes.Maybe<
        ReadonlyArray<
            Pick<
                GatsbyTypes.MarkdownRemarkFrontmatterBodyContact_social_media,
                'alternative_text' | 'name' | 'link' | 'open_in_new_tab'
            > & { readonly icon: GatsbyTypes.Maybe<Pick<GatsbyTypes.File, 'id' | 'extension' | 'publicURL'>> }
        >
    >
}

export const MapSection: React.FC<Props> = ({ name, address, social_media }) => {
    const {
        state: { theme },
    } = useContext(ThemeContext)
    return (
        <div className="max-w-xl bg-white rounded-2xl z-0 dark:bg-body-bg1-dm relative">
            <img
                src={theme === themes.dark ? MapDmImage : MapImage}
                alt="map"
                className="rounded-2xl relative"
                width="570"
                height="410"
            />
            <div className="absolute rounded-lg bg-body-bg1-dm dark:bg-body-bg1-dm py-3.5 px-7 left-0 right-0 w-230 xxmd:w-68 sm:-top-4 -bottom-12 sm:bottom-auto top-auto ml-auto mr-auto">
                <p className=" text-white pb-2 font-inter font-semibold text-lg">{name}</p>
                <p
                    dangerouslySetInnerHTML={{ __html: address }}
                    className=" text-white-clear text-opacity-70 -mt-1 pb-2 text-left  leading-small font-inter font-light font-base"
                />
            </div>
            <ul className=" hidden sm:flex first:ml-0 absolute bottom-1 left-0 p-4 ">
                {social_media &&
                    social_media.map((mediaIcon) => (
                        <li className="mx-2" key={mediaIcon.icon?.id}>
                            <CustomLink
                                type="external"
                                url={mediaIcon.link}
                                newTab={mediaIcon.open_in_new_tab || false}
                            >
                                <div className={theme === themes.dark ? style.lightModeIconFill : style.darkModeIconFill}>
                                    {mediaIcon.icon?.publicURL && (
                                        <ReactSVG
                                            src={mediaIcon.icon.publicURL}
                                            aria-label={mediaIcon.name || 'icon'}
                                        />
                                    )}
                                </div>
                            </CustomLink>
                        </li>
                    ))}
            </ul>
        </div>
    )
}
